var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBadgeCheckFillSelected = function SvgBadgeCheckFillSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#292A2E",
    fillRule: "evenodd",
    d: "M6.6 2.91a4.02 4.02 0 0 0 2.29-.95 4.024 4.024 0 0 1 5.22 0c.644.55 1.445.882 2.29.95a4.024 4.024 0 0 1 3.69 3.69c.067.844.4 1.646.95 2.29a4.024 4.024 0 0 1 0 5.22 4.03 4.03 0 0 0-.95 2.29 4.025 4.025 0 0 1-3.69 3.69c-.845.068-1.646.4-2.29.95a4.024 4.024 0 0 1-5.22 0 4.03 4.03 0 0 0-2.29-.95 4.024 4.024 0 0 1-3.69-3.69 4.02 4.02 0 0 0-.95-2.29 4.024 4.024 0 0 1 0-5.22c.55-.644.882-1.445.95-2.29A4.024 4.024 0 0 1 6.6 2.91m9.766 6.893a1.312 1.312 0 0 0-1.856-1.856l-4.322 4.322-1.698-1.697a1.313 1.313 0 0 0-1.856 1.856l2.626 2.625a1.31 1.31 0 0 0 1.855 0z",
    clipRule: "evenodd"
  })));
};
export default SvgBadgeCheckFillSelected;